export default __webpack_public_path__ + "static/media/PrintedMaterial2.da6b0c25.png";